module.exports = __webpack_public_path__ + "static/media/crow_roti01.e6c24d62.gif";